import { InputTag } from 'mixs/base/input_mixin';
import { PLANNER_CHANGE_STATUS } from 'apps/events';
export class RadioStatus extends InputTag {
  public init() {
    super.init();
    this.watch();
  }
  public onChange(e){
    let customEvent = new CustomEvent(PLANNER_CHANGE_STATUS);
    document.dispatchEvent(customEvent);
  }
}

riot.mixin('inputs.complex.radio-status', RadioStatus as riot.TagMixin)
